import React from "react"

// @ts-ignore
import Back from "url:assets/images/icons/Back.svg"

export function BackArrowIcon({}) {
  return <img src={Back} />
}
